module.exports = __webpack_public_path__ + "static/media/22ESCWA3.ac5b7551.jpg";